import config from "@/config";
import http from "@/utils/request";

export default {
	list: {
		url: `${config.API_URL}/api/ly/course/topic/page`,
		name: "课程专题列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	add: {
		url: `${config.API_URL}/api/ly/course/topic/save`,
		name: "新增课程专题",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	detail: {
		url: `${config.API_URL}/admin/online_classes/getDetail`,
		name: "线上课详情",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	update: {
		url: `${config.API_URL}/api/ly/course/topic/update`,
		name: "更新课程专题",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	topicDelete: {
		url: `${config.API_URL}/api/ly/course/topic/delete`,
		name: "删除课程专题",
		delete: async function (id) {
			return await http.delete(`${this.url}/${id}`);
		},
	},
	topicList: {
		url: `${config.API_URL}/api/ly/course/topic/course/topic/list`,
		name: "专题课程列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	sort: {
		url: `${config.API_URL}/api/ly/course/topic/update/course/sort`,
		name: "修改课程排序",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	remove: {
		url: `${config.API_URL}/api/ly/course/topic/remove/course`,
		name: "移除课程",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	addProduct: {
		url: `${config.API_URL}/api/ly/course/topic/course/add`,
		name: "添加课程",
		post: async function (params) {
			return await http.post(this.url, params);
		},
	},
	addList: {
		url: `${config.API_URL}/api/ly/course/topic/course/list`,
		name: "可添加课程列表",
		get: async function (params) {
			return await http.get(this.url, params);
		},
	},
	online: {
		delete: {
			url: `${config.API_URL}/admin/online_classes/del`,
			name: "删除线上课",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
	liveCourse: {
		list: {
			url: `${config.API_URL}/admin/live_course/list`,
			name: "直播课程列表",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		detail: {
			url: `${config.API_URL}/admin/live_course/detail`,
			name: "直播课程详情",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
		store: {
			url: `${config.API_URL}/admin/live_course/store`,
			name: "直播课程新增/编辑",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		save: {
			url: `${config.API_URL}/admin/live_course/save`,
			name: "保存直播课程",
			post: async function (params) {
				return await http.post(this.url, params);
			},
		},
		delete: {
			url: `${config.API_URL}/admin/live_course/del`,
			name: "删除直播课程",
			get: async function (params) {
				return await http.get(this.url, params);
			},
		},
	},
};
